import { h } from '@stencil/core';
import cn from 'classnames';
import { isEqual } from 'lodash';
import { html2plain } from '../../../globals/utils/helpers';
export class PesSelect {
  constructor() {
    this.setSelectedValue = () => {
      var _a;
      this.selected = (_a = this.items.find((item) => {
        return item.selected === true;
      })) === null || _a === void 0 ? void 0 : _a.value;
    };
    this.items = [];
    this.hasFixedWidth = true;
    this.selected = undefined;
    this.updateCount = 0;
  }
  handleSelect(event) {
    this.selectedValue.emit({ selectedValue: event.target.value });
  }
  handleItemsUpdate(newValue, previousValue) {
    if (isEqual(newValue, previousValue))
      return;
    this.updateCount++;
    this.setSelectedValue();
  }
  componentWillLoad() {
    this.setSelectedValue();
  }
  render() {
    return (h("qds-select", { key: this.updateCount, class: cn('pes-select', { 'pes-select--fixed-width': this.hasFixedWidth }), value: this.selected, onQdsChange: (event) => this.handleSelect(event) }, this.items.map(({ value, label, selected }) => {
      return (h("option", { value: value, key: value, selected: selected }, html2plain(label)));
    })));
  }
  static get is() { return "pes-select"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["select.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["select.css"]
    };
  }
  static get properties() {
    return {
      "items": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "SelectItem[]",
          "resolved": "SelectItem[]",
          "references": {
            "SelectItem": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Items to display in pes-select."
        },
        "defaultValue": "[]"
      },
      "hasFixedWidth": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If true, qds-select will have fixed width defined in stylesheet."
        },
        "attribute": "has-fixed-width",
        "reflect": false,
        "defaultValue": "true"
      }
    };
  }
  static get states() {
    return {
      "selected": {},
      "updateCount": {}
    };
  }
  static get events() {
    return [{
        "method": "selectedValue",
        "name": "selectedValue",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": "Fired onQdsChange select.\nContains selected value."
        },
        "complexType": {
          "original": "SelectedValueEventDetail",
          "resolved": "{ selectedValue: string; }",
          "references": {
            "SelectedValueEventDetail": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        }
      }];
  }
  static get watchers() {
    return [{
        "propName": "items",
        "methodName": "handleItemsUpdate"
      }];
  }
}
